import { Inject, Injectable, OnDestroy } from '@angular/core';

import { AppConfig, CMPS_APP_CONFIG } from '../../app.config';
import { AuthService } from '../../auth/auth.service';
import { DefaultSocketService } from '../../common/websocket';

import { HubMethods } from './model/hub-methods.model';

@Injectable({ providedIn: 'root' })
export class SocketService extends DefaultSocketService implements OnDestroy {
    constructor(
        private readonly _authService2: AuthService,
        @Inject(CMPS_APP_CONFIG) private readonly _appConfig: AppConfig,
    ) {
        super(_authService2);
    }

    ngOnDestroy(): void {
        this._destroy();
    }

    async retrieveCaMeetingRequestContext(): Promise<void> {
        await this.send(HubMethods.RetrieveCaMeetingRequestContext);
    }

    async retrieveCurrentCaResult(): Promise<void> {
        await this.send(HubMethods.RetrieveCurrentCaResult);
    }

    protected _websocketUrl(): string {
        return `${this._appConfig.API_ENDPOINTS.COACHING ?? ''}/ws`;
    }
}
